// Local translations
export const T = {
  en_GB: {
    removeField: "Remove field",
    settings: "Settings",
    financialSituationModels: "Financial Situation Models",
    configureFieldDefinitions: "Configure field definitions for this model",
    notFound: "Model not found",
    loading: "Loading...",
    save: "Save",
    error: "Error",
    changesSaved: "Saved",
    failedToSave: "Failed to save",
    // Fields
    fieldDefinitions: "Field Definitions",
    fieldDefinitionsDescription:
      "Define the fields that will be collected in each category — separately for person, company and group clients.",
    income: "Income",
    assets: "Assets",
    liabilities: "Liabilities",
    commitments: "Commitments",
    label: "Label",
    fieldLabelPlaceholder: "Field label",
    syncKey: "Sync key",
    syncKeyPlaceholder: "e.g., SAVING_ACCOUNT",
    syncKeyHelp:
      "Identifier an integration uses as typeSyncKey on the public API instead of the field id. Must be unique among the fields of this client type.",
    syncKeyDuplicate: "This sync key is used by another field of this client type.",
    required: "Required",
    requiredHelp:
      "The advisor must enter a value: the field is pre-filled in the financial situation component and the flow cannot be submitted without an amount.",
    monthly: "Monthly",
    addField: "Add Field",
    newField: "New Field",
    // QP-176 / QL-140 — separate person / company / group views
    persons: "Persons",
    companies: "Companies",
    groups: "Groups",
    noCompanyFields: "No company fields yet. Fields added here are only shown for company clients.",
    noGroupFields: "No group fields yet. Fields added here are only shown for group clients.",
  },
  nb_NO: {
    removeField: "Fjern felt",
    settings: "Innstillinger",
    financialSituationModels: "Økonomiske situasjonsmodeller",
    configureFieldDefinitions: "Konfigurer feltdefinisjoner for denne modellen",
    notFound: "Modell ikke funnet",
    loading: "Laster...",
    save: "Lagre",
    error: "Feil",
    changesSaved: "Lagret",
    failedToSave: "Kunne ikke lagre",
    // Fields
    fieldDefinitions: "Feltdefinisjoner",
    fieldDefinitionsDescription:
      "Definer feltene som skal samles inn i hver kategori — separat for personkunder, selskapskunder og gruppekunder.",
    income: "Inntekt",
    assets: "Eiendeler",
    liabilities: "Gjeld",
    commitments: "Forpliktelser",
    label: "Etikett",
    fieldLabelPlaceholder: "Feltetikett",
    syncKey: "Synkronøkkel",
    syncKeyPlaceholder: "f.eks. SAVING_ACCOUNT",
    syncKeyHelp:
      "Identifikator en integrasjon bruker som typeSyncKey i det offentlige API-et i stedet for felt-id. Må være unik blant feltene for denne kundetypen.",
    syncKeyDuplicate: "Denne synkronøkkelen brukes av et annet felt for denne kundetypen.",
    required: "Påkrevd",
    requiredHelp:
      "Rådgiveren må fylle inn en verdi: feltet forhåndsutfylles i komponenten for økonomisk situasjon, og flyten kan ikke sendes inn uten beløp.",
    monthly: "Månedlig",
    addField: "Legg til felt",
    newField: "Nytt felt",
    // QP-176 / QL-140 — separate person / company / group views
    persons: "Personer",
    companies: "Selskaper",
    groups: "Grupper",
    noCompanyFields:
      "Ingen selskapsfelt ennå. Felt som legges til her vises kun for selskapskunder.",
    noGroupFields: "Ingen gruppefelt ennå. Felt som legges til her vises kun for gruppekunder.",
  },
} as const;
